module.exports = __webpack_public_path__ + "static/media/buying-small.1b596752.jpg";